import React, { FC } from 'react';
import OWTag from '../../common/OWTag';

const TSProblemTypesDisplay: FC<any> = ({ problemTypes = [], notSpecified }) => {
	return (
		<div className="flex flex-row flex-wrap items-center gap-2">
			{problemTypes.length > 0 ? (
				problemTypes
					.map((_) => _.hierarchyName || _.name)
					.map((pt, idx) => <OWTag key={`ts-pt-${idx}`}>{pt}</OWTag>)
			) : (
				<OWTag>{'All Problem Types'}</OWTag>
			)}
		</div>
	);
};

export default TSProblemTypesDisplay;
